import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {XCloseIcon} from '@/components/ui/icon/Icon'
import {Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle} from '@/components/ui/modal-atoms/ModalAtoms'
import {formatLocaleDate} from '@/dayjs'
import {MedicalReportDetailsHeading} from '@/features/medical-reports/components/medical-report-details-heading/MedicalReportDetailsHeading'
import {UserByPatient} from '@/features/users/types'
import {useTranslation} from '@/translations/i18n'

export const MedicalRecordAggregatedPrintViewerModal = ({
    closeModal,
    date,
    user,
    pdfAttachmentUrl
}: {
    closeModal: () => void
    date: string
    user: UserByPatient
    pdfAttachmentUrl: string
}) => {
    const {t} = useTranslation()

    return (
        <Modal width="1024px" overflowY="unset">
            <ModalHeader>
                <Flexbox direction="column" gap={2}>
                    <Flexbox fullWidth justify="space-between" align="center">
                        <ModalTitle>{t('medical_records:aggregate_reports')}</ModalTitle>
                        <Button shape="square" variant="ghost" onClick={closeModal}>
                            <XCloseIcon />
                        </Button>
                    </Flexbox>
                    <MedicalReportDetailsHeading
                        date={formatLocaleDate(date, 'MMM YYYY')}
                        createdByFullName={user.fullName}
                        specializationName={''}
                        isAggregatedPrint
                    />
                </Flexbox>
            </ModalHeader>
            <ModalBody>
                <iframe width={960} height={500} src={pdfAttachmentUrl} />
            </ModalBody>
            <ModalFooter>
                <Flexbox justify="flex-end" gap={2} fullWidth>
                    <Button onClick={closeModal} variant="secondary">
                        {t('commons:close')}
                    </Button>
                    <ButtonLink to={pdfAttachmentUrl} target="_blank" variant="primaryNeutral">
                        {t('commons:print')}
                    </ButtonLink>
                </Flexbox>
            </ModalFooter>
        </Modal>
    )
}
